import { v4 as uuid } from 'uuid';
export function setupRequestIdInterceptor(client) {
    client.interceptors.request.use((config) => {
        if (!config.headers['X-Request-Id']) {
            config.headers['X-Request-Id'] = uuid();
        }
        return config;
    });
}
